import { View } from './config/app.js'

class Component
{
	constructor(element)
	{
		if (element.hasAttribute('ui-component-ready'))
			return

		element.setAttribute('ui-component-ready', '')
		element.setAttribute('ui-component', this.constructor.name)

		this.element = element
		if (!this.element.uiComponent)
			this.element.uiComponent = {}
		this.element.uiComponent[this.constructor.name] = this

		if (this.element.hasAttribute('ui-view'))
		{
			this.view = View.create({ name: this.element.getAttribute('ui-view') })
			this.element.addEventListener('view.render', () => this.init)
		}
		else
		{
			this.init()
		}
	}

	init()
	{

	}
}

export default Component
